import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'uc-university-information-card',
	templateUrl: './university-information-card.component.html',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversityInformationCardComponent {
	cardTitle = input<string>();
	value = input<string | number | null>();
}
